import React, { useEffect } from 'react';
import Header from 'feature/common/landing/header/header';
import Features from 'feature/common/landing/features/features';
import Usage from 'feature/common/landing/usage/usage';
import Rebate from 'feature/common/landing/rebate/rebate';
import Settings from 'feature/common/landing/settings/settings';
import Support from 'feature/common/landing/support/support';
import Download from 'feature/common/landing/download/download';
import Start from 'feature/common/landing/start/start';
import { isMochipay, isMochiService } from 'config';
import { LandingHeader } from 'utils/header-helper';
import amplitudeService from 'service/amplitude';
import analyticsService from 'service/analytics';
import { useLocation } from 'react-router-dom';

const LandingPage = () => {
  const location = useLocation();
  useEffect(() => {
    amplitudeService.track('服務介紹頁-landingpage_pageview');
    analyticsService.track('autopass_refueling_main_view');
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (location.hash) {
      let elem = document.getElementById(location.hash.slice(1));
      if (elem) {
        elem.scrollIntoView();
      }
    }
  }, [location]);

  return (
    <>
      <LandingHeader />
      <Header />
      <Features />
      <Usage />
      <Rebate />
      <Settings />
      {isMochiService && <Download />}
      <Support />
      {isMochipay && <Start />}
    </>
  );
};

export default LandingPage;
